import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { MainApi } from '_api';
import { handleError, handleResponse } from '_helpers/api';

export const getFileTypes = createAsyncThunk(
  'variants/getFileTypes',
  async function ({ productCode }, { rejectWithValue }) {
    try {
      const response = await MainApi.getFileTypes({ productCode });
      return handleResponse(response);
    } catch (e) {
      return rejectWithValue(handleError(e));
    }
  }
);

const variantsSlice = createSlice({
  name: 'variants',
  initialState: {
    fileTypes: {
      data: [],
      error: null,
      loading: false,
    },
  },
  reducers: {
    resetErrors(state) {
      state.fileTypes.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFileTypes.pending, (state) => {
        state.fileTypes.error = null;
        state.fileTypes.loading = true;
      })
      .addCase(getFileTypes.fulfilled, (state, action) => {
        state.fileTypes.data = action.payload;
        state.fileTypes.loading = false;
      })
      .addCase(getFileTypes.rejected, (state, action) => {
        state.fileTypes.error = action.payload;
        state.fileTypes.loading = false;
      });
  },
});

export const { resetErrors } = variantsSlice.actions;

export default variantsSlice.reducer;
